export default "__VITE_ASSET__dcc1fb7e__"